import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import {getCategoryByValue, getJobTypeByValue, getLabelByValue} from "../Jobs/JobCard";
import React from "react";
import "../CV/CV.css"
import Box from "@mui/material/Box";

function ApplicationJobCard({job}) {
    return (
        <Grid container direction={"column"} padding={2} spacing={2}>
            <Box>
                <Grid item xs={12}>
                    <Grid container direction={"row"} padding={2} spacing={2}>
                        <Grid container direction={"row"} spacing={2}>
                            {
                                job.jobDetails.jobPlacement ? job.jobDetails.jobPlacement.map((city, index) => (
                                    <Grid item key={index}>
                                        <Chip
                                            variant={"outlined"}
                                            label={city}
                                            style={{width: 'fit-content', color: '#FF6600', borderColor: '#FF6600'}}
                                        />
                                    </Grid>
                                )) : ""
                            }

                            <Grid item xs={4} sm={3} md={2} lg={1.5}>
                                <Chip variant={"outlined"} label={getJobTypeByValue(job.jobDetails.jobType)}
                                      style={{width: '100%', color: '#015F5F', borderColor: '#015F5F'}}/>
                            </Grid>

                            <Grid item xs={4} sm={3} md={2} lg={1.5}>
                                <Chip variant={"outlined"} label={job.jobDetails.workModel}
                                      style={{width: '100%', color: '#22AC00', borderColor: '#22AC00'}}/>
                            </Grid>

                            <Grid item xs={4} sm={3} md={2} lg={1.5}>
                                <Chip variant={"outlined"} label={getLabelByValue(job.salaryDetails.salaryBand)}
                                      style={{width: '100%', color: '#7F00AC', borderColor: '#7F00AC'}}/>
                            </Grid>

                            <Grid item xs={4} sm={3} md={2} lg={1.5}>
                                <Chip variant={"outlined"} label={getCategoryByValue(job.jobDetails.jobCategory)}
                                      style={{width: '100%', color: '#ac005c', borderColor: '#ac005c'}}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <div
                            className={"application-paper-body"}>{job.jobDetails.description || ""}</div>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

export default ApplicationJobCard;